import React,{useState,useRef,useEffect,useCallback} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calender from '../../assets/images/calendar.png';
import { GET_DRIVER_LIST,UPDATE_VEHICLE,GET_EDIT_VEHICLE,DELETE_VEHICLE_ASSIGNED_DRIVER } from '../../constant'; 
import { Circles } from 'react-loader-spinner';
import axios from 'axios';
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../../messageBox/customSweetAlert';
import SaveButton  from '../../components/buttons/SaveButton';
import CancelButton from '../../components/buttons/CancelButton';
import {currentDateFormat,restrictSpecialCharacters} from "../../utils";
import { toast ,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useNavigate} from "react-router-dom";
import{vehicleFormValidation} from "../../validation/Validation";
import Calender from "../../components/Calendar";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
//import Loader from '../../components/loader/Loader';

function VehicleEdit() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
    //const loading = useSelector((state) => state.loader.loading);
    const { id } = useParams();
    let currentInputIndex = 0;
    const [errors,setErrors] = useState({});
    const [restart,setRestart] = useState(false);
    const [endDate, setEndDate] = useState();
    const [startDate, setStartDate] = useState();
    const [insuranceStartDate, setInsuranceStartDate] = useState();
    const [insuranceEndDate, setInsuranceEndDate] = useState();
    const [currentDate,setCurrentDate] = useState(new Date());
    const inputRef = useRef(null);
    const formRef  = useRef({});
    const selectref = useRef('');
    const [myArray, setMyArray] = useState([]);
    const [driverDetails,setDriverDetails] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    //const [loading, setLoading] = useState(false);
    const [viewDetails,setViewDetails]=useState();
    const [editDriverDetails,setEditDriverDetails] = useState();
    const [vehicleDetails,setvehicleDetails] = useState({
      vehicle_name:'',
      vehicle_make:'',
      vehicle_model:'',
      model_year:'',
      license_plate:'',
      driverIds:[],
      vehicle_number:'',
      vin_number:'',
      vehicle_type:'',
      select_method:'',
      make_method:'',
      seating_capacity:'',
      wheel_capacity:'',
      car_seat_availability:'',
      car_seat_type:'',
      is_certified:'',
      start_date:'',
      end_date:'',
      is_insured:'',
      insurance_start_date:'',
      insurance_end_date:'',
      tie_down_position:'',
      tie_downs:'',
      seat_availability:''});
  
      async function handleFormSubmit(e) {
        e.preventDefault();
         const isValid =    vehicleFormValidation(vehicleDetails);
         setErrors(isValid);
         if(Object.keys(isValid).length === 0){
        try {
          dispatch(setLoading(true));
            const response = await axios.post(UPDATE_VEHICLE, vehicleDetails);
            
            console.log(response.data.status);
            if (response.data.status === '200') {
                //console.log('response');
                dispatch(setLoading(false));
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'OK',
                  });
                  navigate('/home/vehicle/list', { replace: true });
                
            } else {
              dispatch(setLoading(false));
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message,
                    icon: 'Error',
                    confirmButtonText: 'OK',
                  });
                console.log(response.data.message);
            }
        } catch (error) {
          dispatch(setLoading(false));
            console.error("Error logging in:", error);
        }
      }
    }
    const loadUser = useCallback(async () => {
      dispatch(setLoading(true));
        const result = await axios.get(GET_DRIVER_LIST);
        const response_2 = await axios.get(GET_EDIT_VEHICLE + '/' + `${id}`);
        //console.log("test driver details === ", response_2.data);
        if(response_2.data){
        setDriverDetails(result.data);
        setViewDetails(response_2.data.vehicle);
       
        setStartDate(response_2.data.vehicle.mtm_start_date || null);
        setEndDate(response_2.data.vehicle.mtm_end_date || null);
        setInsuranceStartDate(response_2.data.vehicle.insurance_start_date);
        setInsuranceEndDate(response_2.data.vehicle.insurance_end_date);
        setEditDriverDetails(response_2.data.driverDetails);
        // console.log("test driver details === ", response_2.data);
         //console.log("test = ",response_2);
        
        if (response_2.data !==0) {
           console.log("dd",response_2.data);
            setvehicleDetails({
              vehicle_name:response_2.data.vehicle.vehicle_name,
              vehicle_make:response_2.data.vehicle.vehicle_make,
              vehicle_model:response_2.data.vehicle.vehicle_model,
              model_year:response_2.data.vehicle.model_year,
              license_plate:response_2.data.vehicle.license_plate_type,
              driverIds:[],
              vehicle_number:response_2.data.vehicle.stc_vehicle_no,
              vin_number:response_2.data.vehicle.vin_no,
              vehicle_type:response_2.data.vehicle.vehicle_type,
              select_method:response_2.data.vehicle.select_method,
              make_method:response_2.data.vehicle.make_of_life,
              seating_capacity:response_2.data.vehicle.seating_capacity,
              wheel_capacity:response_2.data.vehicle.wheel_chair_capacity,
              car_seat_availability:response_2.data.vehicle.car_seat_availability,
              car_seat_type:response_2.data.vehicle.car_seat_type,
              is_certified:response_2.data.vehicle.is_mtm_certified,
              start_date:moment(response_2.data.vehicle?.mtm_start_date).format('DD/MM/yyyy'),
              end_date:moment(response_2.data.vehicle?.mtm_end_date).format('DD/MM/yyyy'),
              is_insured:response_2.data.vehicle.is_insurance_available,
              insurance_start_date:moment(response_2.data.vehicle?.insurance_start_date).format('DD/MM/yyyy'),
              insurance_end_date:moment(response_2.data?.vehicle.insurance_end_date).format('DD/MM/yyyy'),
              tie_down_position:response_2.data.vehicle.tie_down_position,
              tie_downs:response_2.data.vehicle.tie_down,
              seat_availability:response_2.data.vehicle.stretcher_availability,
              vehicleId: id });
              dispatch(setLoading(false));
    }
    else{
        console.log('no dat found..')
    }
 } }, [id]);
  
      useEffect(() => {
        
      loadUser();
    }, [restart]);
  
      // const generateInput = (e)=> {
      //   let inputcount = document.getElementsByName('e_name').length+1;
      //   e.preventDefault();
      //   const input = document.createElement('input');
      //   input.type = 'text';
      //   input.setAttribute('data-index',formRef.current.querySelectorAll('.my-3').length);
      //   input.classList.add('form-control', 'my-3');
      //   input.name = 'e_name';
      //   input.setAttribute('autocomplete', 'off');
      //   input.id='driver_' + inputcount;
      //   input.addEventListener('keyup', onChangeHandler);
      //   input.addEventListener('change', handleInputChange);
      //   document.getElementById('inputs-section2').appendChild(input);
        
      // }
  
    const handleInputChange=(e)=>{
      const {name,value}=e.target;
      setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
      setvehicleDetails((prev)=>{
          return{
           ...prev,
            [name]:value,
            driverIds:  Array.from(formRef.current.querySelectorAll('.my-3')).map((input) => input.value  ),
          }
      });
  }
  // const handleHiddenInputChange=(e)=>{
  //   console.log(formRef.current.querySelectorAll('.user_id'));
  //   setvehicleDetails((prev)=>{
  //       return{
  //           ...prev,
  //       userId:  Array.from(formRef.current.querySelectorAll('.user_id')).map((input) => input.value  ),
  //      //Ids:  inputRef.current.dataset.code
  //       }
  //   });
  // }
  // const onSuggestHandler = (text,id) => {
  //   //console.log('haiii-',driverDetails);
  //   currentInputIndex= localStorage.getItem('InputIndex') || 0;
  //   const driverDetails=vehicleDetails.driverIds.map((value,index)=>{
  //       if(index == currentInputIndex)
  //           { 
  //            return {text,id};}
  //        else{ return value; }
  //   });
    
  //   setMyArray((prevData) => {
  //       return [...prevData, id]; // spread the previous array and add the new id
  //     });
  //     const prevArray = [...myArray, id];
  //     setvehicleDetails((prev)=>{
  //       return{
  //        ...prev,
  //        driverIds:  [...driverDetails],
  //       userIds: [...prevArray, ...editDriverDetails.map((item)=>item.user_id.toString())]
  //       }
        
  //   });
  //     //handleHiddenInputChange();
  //   userSuggestionData(driverDetails);
  //   setSuggestions([]);
  // };
  // const userSuggestionData = (passenger)=>{
             
  //   var inputs = document.querySelectorAll('.my-3');
  //      for (var i = 0; i < inputs.length; i++) {
  //          //inputs[i].value = passenger[i] || '';
  //          if (typeof passenger[i] === 'string') {
  //              inputs[i].value = passenger[i];
  //            } else if (typeof passenger[i] === 'object') {
  //              inputs[i].value = passenger[i].text || '';
  //            } else {
  //              inputs[i].value = '';
  //            }
  //      }
  //  }
  //  const onChangeHandler = (e)=>{
  //   console.log('Key up event triggered:', e.target);
  //   let text = e.target.value ? e.target.value : "";
  //   let inputIndex = e.target.dataset.index;
  //   localStorage.setItem('InputIndex',inputIndex);
  //   //console.log( e.target);
  //       let matches = [];
  //       if(text.length > 0){
  //           matches = driverDetails.filter(user =>{
  //               const regex = new RegExp(`${text}`,"gi");
  //               return user.first_name.match(regex) || user.user_id.toString().match(regex);
  //           })
  //       }
  //       setSuggestions(matches);
  //      //console.log(matches);
  // }
 
  const deleteDriver=(userId)=>{
    Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this item!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then((result) => {
        if (result.isConfirmed) {

            axios.delete(DELETE_VEHICLE_ASSIGNED_DRIVER + '/' + id + '/'+ `${userId}`)
            .then((response)=>{
              console.log(response);
                if(response.data.status === 200){
                  setLoading(false);
                  Swal.fire({
                    title: 'Error!',
                    text: response.data.message,
                    icon: 'Error',
                    confirmButtonText: 'OK',
                  });
                  setRestart(true);
                    // toast.success(response.data.message, { position: "top-center" });
                    // setEditDriverDetails(
                    //     editDriverDetails.filter(a =>
                    //       a.user_id !== `${userId}`
                    //     )
                    //   );
                }else{
                    toast.error(response.data.message, { position: "top-center" });
                }
                //console.log(response);
            }).catch(error => {
                toast.error(error, { position: "top-center" });
              })
            //alert(userId);
            
          
        }
      });
        
     }
  
  
  return(
  
  
      <>
      {/* <div>
      {loading && <Loader />}
    </div> */}
      <div className="tab-pane fade active show " id="add-vehicle" role="tabpanel" aria-labelledby="profile-tab">
      <div className="container-fluid px-mobile-2">
        <section>
          <div className='d-flex justify-content-between form-container'>
            <div>
              <h2 className="fs-5 font-weight-600">Edit Vehicle</h2>
            </div>
            <div>
              <ToastContainer />
            </div>
            <div>
              <span>{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <section>
          <div className='bg-white  px-5 py-4'>
            <div>
              <p className="sub-title">Vehicle Information</p>
            </div>
            <form onSubmit={handleFormSubmit} ref={formRef}>
              <div className="form-items">
                <div>
                  <label className='require-field'>Vehicle Name</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.vehicle_name ?? ''} className="form-control" id="vehicle_name" name="vehicle_name" onChange={handleInputChange} />
                  {errors.vehicle_name && <span className='errors'>{errors.vehicle_name}</span>}
                </div>
                <div>
                  <label>Vehicle Make</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.vehicle_make ?? ''} className="form-control" id="vehicle_make" name="vehicle_make" onChange={handleInputChange} />
                </div>
                <div>
                  <label className='require-field'>Vehicle Model</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.vehicle_model ?? ''} className="form-control" id="vehicle_model" name="vehicle_model" onChange={handleInputChange} />
                  {errors.vehicle_make && <span className='errors'>{errors.vehicle_make}</span>}
                </div>
                <div>
                  <label>Model Year</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.model_year ?? ''} className="form-control" id="model_year" name="model_year" onChange={handleInputChange} />
                  {errors.vehicle_model && <span className='errors'>{errors.vehicle_model}</span>}
                </div>
                
                <div>
                   <label  className='require-field'>License Plate #</label>
                   <div>
                     <input 
                        type="text" 
                        autoComplete='off' 
                        className="form-control" 
                         id="license_plate" 
                         name="license_plate"  
                         onChange={handleInputChange}
                         onKeyDown={restrictSpecialCharacters} />
                          {errors.license_plate && <span className='errors'>{errors.license_plate}</span> }
                   </div>
               </div>
                <div className="form-item">
                  <label>STC Vehicle Number</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.stc_vehicle_no ?? ''} className="form-control" id="vehicle_number" name="vehicle_number" onChange={handleInputChange} />
                  {errors.vehicle_number && <span className='errors'>{errors.vehicle_number}</span>}
                </div>
                <div className="form-item">
                  <label>VIN Number</label>
                  <input type="number" autoComplete='off' defaultValue={viewDetails?.vin_no ?? ''} className="form-control" id="vin_number" name="vin_number" onChange={handleInputChange} />
                </div>
                <div>
                  <label>Vehicle Type</label>
                  <div>
                    <select className="form-select" value={viewDetails?.vehicle_type} aria-label="Default select example" name="vehicle_type" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Van</option>
                      <option value="2">option 2</option>
                    </select>
                  </div>
                  {errors.vehicle_type && <span className='errors'>{errors.vehicle_type}</span>}
                </div>
                <div>
                  <label>Select Method</label>
                  <div>
                    <select className="form-select" value={viewDetails?.select_method} aria-label="Default select example" name="select_method" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Lift</option>
                      <option value="2">option 2</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Make of Life or Ramp</label>
                  <div>
                    <select className="form-select" value={viewDetails?.make_of_life} aria-label="Default select example" onChange={handleInputChange} name="make_method">
                      <option value="">Select</option>
                      <option value="1">Lift</option>
                      <option value="2">option 2</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Seating Capacity</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.seating_capacity ?? ''} className="form-control" id="seating-capacity" name="seating_capacity" onChange={handleInputChange} />
                </div>
                <div>
                  <label>Wheel Chair Capacity</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.wheel_chair_capacity ?? ''} className="form-control" id="wheel_capacity" name="wheel_capacity" onChange={handleInputChange} />
                </div>
                <div className="form-item-span">
                  <label>Stretcher Availability</label>
                  <div>
                    <select className="form-select" value={viewDetails?.stretcher_availability} aria-label="Default select example" name="seat_availability" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Car Seat Availability</label>
                  <div>
                    <select className="form-select" value={viewDetails?.car_seat_availability} aria-label="Default select example" name="car_seat_availability" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Car Seat Type</label>
                  <div>
                    <select className="form-select" value={viewDetails?.car_seat_type} aria-label="Default select example" name="car_seat_type" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Baby Car Sear</option>
                      <option value="2">option 2</option>
                    </select>
                  </div>
                </div>
                <div className="form-item-span">
                  <p className="font-small pb-3 font-weight-600">Is the vehicle MTM certified ?</p>
                  <div>
                    <select className="form-select" value={vehicleDetails?.is_certified} aria-label="Default select example" name="is_certified" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                  {errors.is_certified && <span className='errors'>{errors.is_certified}</span>}
                </div>
                <div style={{paddingTop:'26px'}}>
                <div className="date-selector align-self-md-end">
                  <label>Start Date</label>
                  
                  <Calender
                    selected={startDate}
                    onChange={handleInputChange}
                    setDate={setStartDate}
                    name="start_date"
                    id="start_date"
                    //errors={errors.start_date}
                     />
                </div>
                <div className="error-message">
                      {errors.start_date && <span className='errors'>{errors.start_date}</span> }
                   </div>
                   </div>
                   <div style={{paddingTop:'26px'}}>
                <div className="date-selector align-self-md-end">
                  <label>End Date</label>
                  
                  <Calender
                    selected={endDate}
                    onChange={handleInputChange}
                    setDate={setEndDate}
                    name="end_date"
                    id="end_date"
                    //errors={errors.end_date} 
                    />
                </div>
                <div className="error-message">
                      {errors.end_date && <span className='errors'>{errors.end_date}</span> }
                   </div>
                </div>
                <div className="form-item-span">
                  <p className="font-small pb-3 font-weight-600">Is the vehicle Insured?</p>
                  <div>
                    <select className="form-select" value={vehicleDetails?.is_insured} aria-label="Default select example" name="is_insured" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                  {errors.is_insured && <span className='errors'>{errors.is_insured}</span>}
                </div>
                <div style={{paddingTop:'26px'}}>
                <div className="date-selector align-self-md-end">
                  <label>Start Date</label>
                  <Calender
                    selected={insuranceStartDate}
                    onChange={handleInputChange}
                    setDate={setInsuranceStartDate}
                    name="insurance_start_date"
                    id="insurance_start_date"
                    //errors={errors.insurance_start_date}
                     />
                </div>
                <div className="error-message">
                      {errors.insurance_start_date && <span className='errors'>{errors.insurance_start_date}</span> }
                   </div>
                </div>
                <div style={{paddingTop:'26px'}}>
                <div className="date-selector align-self-md-end">
                  <label>End Date</label>
                  
                  <Calender
                    selected={insuranceEndDate}
                    onChange={handleInputChange}
                    setDate={setInsuranceEndDate}
                    name="insurance_end_date"
                    id="insurance_end_date"
                    errors={errors.insurance_end_date} 
                    />
                </div>
                <div className="error-message">
                      {errors.insurance_end_date && <span className='errors'>{errors.insurance_end_date}</span> }
                   </div>
                </div>
                <div className="form-item-span">
                  <label>Tie Down Positions</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.tie_down_position ?? ''} className="form-control" id="tie_down_position" name="tie_down_position" onChange={handleInputChange} />
                </div>
                <div>
                  <label>Tie Downs</label>
                  <input type="text" autoComplete='off' defaultValue={viewDetails?.tie_down ?? ''} className="form-control" id="tie_downs" name="tie_downs" onChange={handleInputChange} />
                </div>
              </div>

              {/* <div className="py-3">
                <p className='sub-title'>Assign Driver</p>
                <div className="row">
                  <div className="col-lg-3 col-md-4 col-sm-10 pe-0">
                    <div className="d-flex align-items-center">
                      <div id="inputs-section2">

                        <input type="text" data-index='0' ref={inputRef} autoComplete='off'
                          className="form-control my-3" defaultValue={vehicleDetails.driverIds[0] ? vehicleDetails.driverIds[0].text : ''} id="e_name" name="e_name" onChange={(e) => {
                            handleInputChange(e);
                          } } onKeyUp={onChangeHandler} />

                        {console.log(vehicleDetails.driverIds[0] ? vehicleDetails.driverIds[0] : '')}
                        <input type="hidden" className='user_id' name="user_ids" onChange={handleHiddenInputChange} defaultValue={JSON.stringify(myArray)} />
                        {suggestions && suggestions.map((item, index) => (
                          <div className="box-wrapper">
                            <div className='suggestion-box' key={index} onClick={() => onSuggestHandler((item.first_name + " " + (item.middle_name ? item.middle_name : '') + " " + item.last_name + " - " + item.driver?.umpi_no), item.user_id.toString())}>
                              <p> {item.first_name + " " + (item.middle_name ? item.middle_name : '') + " " + item.last_name + " - " + item.driver?.umpi_no}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{ alignSelf: 'end' }}>
                        <p className='ms-3'><i className="pi pi-plus-circle assigned-btn" onClick={generateInput}></i></p>

                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-6 assigned-top-padding">
                    <div className='row'>
                      <div className='col-md-8 col-lg-8 assigned-drivers-sector'>
                        {editDriverDetails && editDriverDetails.map((driverName) => {
                          return (
                            <div key={driverName.user_id} className="driver-list-item d-flex gap-3 align-items-center">
                              <div className='mb-3'>
                                <input type="text" 
                                readOnly 
                                style={{ background: 'rgb(233 227 227)' }} 
                                name="driver_list" 
                                className="form-control" 
                                defaultValue={driverName.first_name + " " + (driverName?.middle_name ?? '') + " " + driverName.last_name} />
                              </div>
                              <div style={{ alignSelf: 'flex-start' }}>
                                <i className="pi pi-trash icon-btn-delete fs-6"
                                  style={{ position: 'relative', top: '10px' }}
                                  onClick={() => deleteDriver(driverName.user_id, `${id}`)}
                                ></i>
                              </div>
                            </div>);
                        })}
                      </div>
                    </div>
                  </div>


                </div>
              </div> */}


              <div className='footer-content'>
                <SaveButton type='submit' buttonTitle={'UPDATE VEHICLE'} />

                <CancelButton cancelHandler={() => navigate('/home/vehicle/list', { replace: true })} />
              </div>
            </form>
          </div>
        </section>
      </div>
    </div></>
  );
}

export default VehicleEdit